import React, { useState } from "react";

type Word = {
    eng: string;
    polish: string;
};

type WordMatchingExerciseProps = {
    words: Word[];
    accentHex?: string;
};

const WordMatchingExercise: React.FC<WordMatchingExerciseProps> = ({
    words,
    accentHex,
}) => {
    // Tasujemy ENG i POL osobno
    const [englishWords] = useState(() =>
        [...words].sort(() => Math.random() - 0.5)
    );
    const [polishWords] = useState(() =>
        [...words].sort(() => Math.random() - 0.5)
    );

    const [selectedEng, setSelectedEng] = useState<string | null>(null);
    const [matchedPairs, setMatchedPairs] = useState<
        { eng: string; polish: string }[]
    >([]);

    const handleSelectPolish = (polish: string) => {
        if (!selectedEng) return;

        const correctPair = words.find(
            (w) => w.eng === selectedEng && w.polish === polish
        );

        if (correctPair) {
            setMatchedPairs((prev) => [...prev, correctPair]);
        }

        setSelectedEng(null);
    };

    const isMatched = (eng: string, polish: string) =>
        matchedPairs.some((p) => p.eng === eng && p.polish === polish);

    return (
        <div className="p-4">
            <h3
                className="text-lg font-bold mb-6 text-center"
                style={{ color: accentHex || "#333" }}
            >
                Match the Words
            </h3>

            <div className="grid grid-cols-2 gap-6">
                {/* Kolumna ENG */}
                <div className="flex flex-col items-center">
                    <h4 className="font-semibold mb-3">English</h4>
                    {englishWords.map((word) => {
                        const matched = matchedPairs.some((p) => p.eng === word.eng);
                        const isSelected = selectedEng === word.eng;
                        return (
                            <button
                                key={word.eng}
                                onClick={() => !matched && setSelectedEng(word.eng)}
                                className={[
                                    "w-4/5 p-3 mb-3 rounded-lg font-semibold transition",
                                    matched
                                        ? "bg-green-500 text-white"
                                        : isSelected
                                            ? "bg-blue-400 text-white"
                                            : "bg-zinc-100 hover:bg-zinc-200 text-zinc-700",
                                ].join(" ")}
                            >
                                {word.eng}
                            </button>
                        );
                    })}
                </div>

                {/* Kolumna POL */}
                <div className="flex flex-col items-center">
                    <h4 className="font-semibold mb-3">Polish</h4>
                    {polishWords.map((word) => {
                        const matched = matchedPairs.some((p) => p.polish === word.polish);
                        return (
                            <button
                                key={word.polish}
                                onClick={() => !matched && handleSelectPolish(word.polish)}
                                className={[
                                    "w-4/5 p-3 mb-3 rounded-lg font-semibold transition",
                                    matched
                                        ? "bg-green-500 text-white"
                                        : "bg-zinc-100 hover:bg-zinc-200 text-zinc-700",
                                ].join(" ")}
                            >
                                {word.polish}
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default WordMatchingExercise;
